export let LOCAL_MODE = false;
export const TEST_MODE = false;
export let PROD_MODE = false;
export let API_SERVER_URL = "";

let UAT_MODE = false;

const HostName = window.location.hostname.trim();

if (HostName === "localhost") {
  LOCAL_MODE = true;
  PROD_MODE = false;
  // API_SERVER_URL = "https://gen-fd-dev-progear-01.azurefd.net/";
  // API_SERVER_URL = "https://corp-api-ind-uat-tas-progear-01.azure-api.net/";
  API_SERVER_URL = "https://xcelerateuat-api.genpact.com/";
  
} else if (HostName === "xceleratedev.genpact.com") {
  LOCAL_MODE = false;
  PROD_MODE = false;
  // API_SERVER_URL = "https://corp-api-ind-dev-tas-progear-01.azure-api.net/";
  API_SERVER_URL = "https://gen-fd-dev-progear-01.azurefd.net/";
} else if (HostName === "xcelerateuat.genpact.com") {
  LOCAL_MODE = false;
  PROD_MODE = false;
  UAT_MODE = true;
  // API_SERVER_URL = "https://corp-api-ind-uat-tas-progear-01.azure-api.net/";
  API_SERVER_URL = "https://xcelerateuat-api.genpact.com/";
} 
else if (HostName === "ldtideapp.genpact.com") {
  LOCAL_MODE = false;
  PROD_MODE = true;
  // PROD API Gateway URL
  // API_SERVER_URL = "https://corp-api-ind-prod-tas-pgr-01.azure-api.net/";
  // PROD FD URL
  API_SERVER_URL = "https://corp-api-ind-prod-tas-pgr-01-hyh9acafc0h3hzh8.z01.azurefd.net/";

}

export const GET_METADATA = API_SERVER_URL + "idea-metadata" ;
export const GET_ALL_IDEA_URL = API_SERVER_URL + "get-all-ideas" + "?";
export const GET_IDEA_URL = API_SERVER_URL + "get-idea" + "?";
export const SUBMIT_IDEA_URL = API_SERVER_URL + "create-idea" + "?";
export const DELEGATE_IDEA_URL = API_SERVER_URL + "delegate-idea" + "?";
export const REVIEW_IDEA_URL = API_SERVER_URL + "review-idea" + "?";
export const UPDATE_IDEA_URL = API_SERVER_URL + "update-idea" + "?";
export const HOMEPAGE_URL = API_SERVER_URL + "home-page-data" + "?";
// productivity module
export const PRODUCTIVITY_PROJECTS_LIST_URL = API_SERVER_URL + "get-projects-for-productivity" + "?";
export const PRODUCTIVITY_PROJECTS_DETAILS_URL = API_SERVER_URL + "productivity-project-details-fetch" + "?";
export const PRODUCTIVITY_PROJECTS_UPDATE_URL = API_SERVER_URL + "upload-productivity-file" + "?";

// dev - 20th workflow
export const IDEA_ADMIN_UPDATE = API_SERVER_URL + "idea-admin-update" + "?";




// create new genai opportunity (15th workflow)
export const CREATE_GENAI_OPPORTUNITY_URL = API_SERVER_URL + "create-opportunity" + "?";
// GenAI APIs (08th workflow)
export const GENAI_UPDATE_OPPORTUNITY_URL = API_SERVER_URL + "genai-update-opportunity" + "?";
// fetch opportunity details (14th workflow)
export const GET_GENAI_DETAILS_URL = API_SERVER_URL + "get-opportunity-details" + "?";
// fetch list of opportunities (12th workflow)
export const GENAI_GET_OPPORTUNITIES_URL = API_SERVER_URL + "get-opportunities" + "?";
// genai upload document (09th workflow)
export const GENAI_DOCUMENT_UPLOAD_URL = API_SERVER_URL + "genai-documents-upload" + "?";



export const POWER_APP_URL = PROD_MODE ?
  "https://apps.powerapps.com/play/e/d566adb5-8e41-441b-9167-60c4f428d211/a/c33810f2-eef8-4cfa-828d-5ecfe53f0a81?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&hint=868f8ac9-a535-44ec-9777-8a40fcdd02b8&sourcetime=1777118804311&source=portal"
  :
  "https://apps.powerapps.com/play/e/8b0408f2-2611-40d1-b79d-a519087832df/a/b81e3cd7-b06b-446a-85b3-c8989a086b55?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&hint=42634530-e6f0-474f-a8cb-c0b87b95b168&sourcetime=1768762750232";

  export const DASHBOARD_URL = PROD_MODE ?
  "https://app.powerbi.com/groups/5adbbdb0-5338-4cae-88d5-30f4bce9b82d/dashboards/e51fac98-60ba-49f1-9b59-4c5cb612126a"
  :
  "https://app.powerbi.com/groups/76f90f24-3c78-48ae-a905-ceac69f4ea6a/dashboards/2d8820d3-548d-4309-8b80-c45cae877586";


  export const VGR_APP_URL = 
  PROD_MODE 
  ?
  "https://apps.powerapps.com/play/e/d566adb5-8e41-441b-9167-60c4f428d211/a/c5778e5c-31ca-49f5-84a2-5d373cc93afe?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&hint=0b45d493-3dd2-4c64-9140-898e9018be7c&sourcetime=1762597882422&source=portal"
  :
  UAT_MODE 
  ? 
  "https://apps.powerapps.com/play/e/8b0408f2-2611-40d1-b79d-a519087832df/a/3f3654ba-6aeb-4b97-b69b-920e447d4778?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&sourcetime=1759922569703&source=portal" 
  : 
  "https://apps.powerapps.com/play/e/ea1a2a4e-2e22-4994-828a-2b5d5e874764/a/037f6403-52a7-4db4-9098-6daa558ca68a?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&hint=b7d22925-4c61-423e-bb9d-0352457dab78&sourcetime=1758281595419";
  


export const TS_PROJECTS_LINK = 
  PROD_MODE 
  ?
  "https://apps.powerapps.com/play/e/d566adb5-8e41-441b-9167-60c4f428d211/a/c5778e5c-31ca-49f5-84a2-5d373cc93afe?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&hint=0b45d493-3dd2-4c64-9140-898e9018be7c&sourcetime=1762597882422&source=portal"
  :
  UAT_MODE 
  ? 
  "https://apps.powerapps.com/play/e/8b0408f2-2611-40d1-b79d-a519087832df/a/64d75f25-995a-41f5-8fe0-5e9e9cb4124b?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&hint=9fea1927-305e-4b15-9507-9b8ac56f233d&sourcetime=1772641439650&source=portal" 
  : 
  "https://apps.powerapps.com/play/e/8b0408f2-2611-40d1-b79d-a519087832df/a/64d75f25-995a-41f5-8fe0-5e9e9cb4124b?tenantId=bdef8a20-aaac-4f80-b3a0-d9a32f99fd33&hint=9fea1927-305e-4b15-9507-9b8ac56f233d&sourcetime=1772641439650&source=portal";




// export const OKTA_BASE_URL = 'https://dev-94209304.okta.com/oauth2/default'; //LOCAL
// export const OKTA_CLIENT_ID = '0oah9trlqHyQUfgwR5d6'; //LOCAL

// export const OKTA_BASE_URL = 'https://genpact.oktapreview.com/oauth2/default'; //UAT
// export const OKTA_CLIENT_ID = '0oa1hlcw4wszdRmUf0x7'; //UAT
// export const OKTA_REDIRECT_URL = 'https://xceleratedev.genpact.com/callback'; //UAT

export const OKTA_BASE_URL = PROD_MODE
  ? "https://genpact.okta-emea.com/oauth2/default" //PROD
  : "https://genpact.oktapreview.com/oauth2/default"; //UAT
export const OKTA_CLIENT_ID = PROD_MODE
  ? "0oa7hodheesQyHj5T0i7" //PROD
  : "0oa1hlcw4wszdRmUf0x7"; //UAT
// export const OKTA_REDIRECT_URL = (LOCAL_MODE)
//     ? 'http://localhost:3000/callback'
//     : (PROD_MODE)
//         ? 'https://ldtideapp.genpact.com/callback' //PROD
//         : 'https://xceleratedev.genpact.com/callback'; //UAT

export const OKTA_REDIRECT_URL = LOCAL_MODE
  ? "http://" + HostName + ":3000/callback"
  : "https://" + HostName + "/callback";

export const POSTLOGOUTREDIRECTURI = LOCAL_MODE
  ? "http://" + HostName + ":3000/"
  : "https://" + HostName + "/";

//Application Constants
export const OTHER_REGIONS = "Other Regions";
export const PENDING = "Pending";
export const APPROVED = "Approved";
export const REJECTED = "Rejected";
export const SENT_BACK = "Sent Back";
export const REQUEST_CANCELLATION = "Cancellation Requested";
export const COMPLETE_STATUS = "Complete";
export const CANCEL = "Cancel"
export const PENDING_DOCUMENTS = 'Pending Documents'
export const DOCUMENTS_UPLOADED = 'Documents Uploaded'
export const AWAITING_MASTER_BLACKBELT_APPROVAL = "Awaiting Master Black Belt Approval";
export const AWAITING_QAULITY_CHECK_REVIEW = "Awaiting Quality Check Review";
export const AWAITING_PROJECT_APPROVAL = "Awaiting Project Approval";
export const AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION= "Awaiting Mentor Approval for Cancellation";

export const PPT_CONTENT = "PPTContent";
export const SIGNOFF_CONTENT = "SignoffContent";
export const GOL_APPROVAL_CONTENT = "golApprovalContent";
export const FPnA_APPROVAL_CONTENT = "fpnaApprovalContent";



//Actions
export const VIEW = "view";
export const EDIT = "edit";
export const DELEGATE = "delegate";
export const UPDATE = "update";
export const APPROVAL = "approval";
export const LEAN_APPROVAL = "leanapproval";
export const PROJECT_VIEW = "projectview";

//Business Constants
export const DATA_BRIDGE_CAMPAIGN = "Data Bridge";
export const X_POLLINATION_CAMPAIGN = "X-Pollination";

//Logo images
export const LOGO_IMAGE =
  "https://xceleratedev.genpact.com/static/media/genpactlogohorizontal.b520869d.png";

//Storage Key Constants
export const USER_DATA = "userData";
export const ACCESS_TOKEN = "accessToken";
export const HOME_DATA = "homeData";

export const BI_FORM_DATE = "03/18/2023";
export const DISPLAYPROJECTTHEME = "11/5/2023";

export const PROJECT_TYPE = [
  {
    value: 0,
    label: "GB",
  },
  {
    value: 1,
    label: "BB",
  },
  {
    value: 2,
    label: "MBB",
  },
];





export const YESORNO = [
  { value: 0, label: "Yes" },
  { value: 1, label: "No" },
];

export const DISCUSSIONLEDBY = [
  { value: 0, label: "Transition led" },
  { value: 1, label: "Analytics led" },
  { value: 2, label: "Ops led" },
  { value: 3, label: "LDT led" },
]

export const REPLICABILITYOPTIONS = [
  { value: 1, label: "Low" },
  { value: 2, label: "Medium" },
  { value: 3, label: "High" },
]


export const AI_DOC_LINK = "https://genpactonline.sharepoint.com/:p:/s/LeanDigitalTransformation/EWNpW9slnDFFp2INIyH8_zoBq9bstWZVevJp6E3Wx8WxsA?e=0cqNVV";
export const AIFIRST = "AI First";
export const AIFIRSTDATE = "02/01/2024";


export const EXCEL_TEMPLATE_FOLDER_PATH = PROD_MODE ?
  "https://genpactonline.sharepoint.com/sites/Progear20_dev/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FProduction%2FTemplate%2FProductivity%20PROD%20Template.xlsx"
  :
  "https://genpactonline.sharepoint.com/sites/Progear20_dev/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FUAT%2FTemplate%2FProductivity%20UAT%20Template.xlsx"



export const EXCEL_DNC_ADMIN_UPLOAD = PROD_MODE ? 
"https://genpactonline.sharepoint.com/sites/Progear20_dev/DNA/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FProduction%2FTemplate%2FDNC_Upload.xlsx"
:
"https://genpactonline.sharepoint.com/sites/Progear20_dev/DNA/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FUAT%2FTemplate%2FDNC_Upload.xlsx"



export const FTE_EXCEL_TEMPLATE_LINK = PROD_MODE ?
"https://genpactonline.sharepoint.com/sites/Progear20_dev/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FProduction%2FTemplate%2FProductivity%20PROD%20FTE%20Template.xlsx"
:
"https://genpactonline.sharepoint.com/sites/Progear20_dev/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FUAT%2FTemplate%2FProductivity%20UAT%20FTE%20Template.xlsx"


export const FTE_EXCEL_DNC_ADMIN_UPLOAD = PROD_MODE ? 
"https://genpactonline.sharepoint.com/sites/Progear20_dev/DNA/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FProduction%2FTemplate%2FDNC_Upload_FTE_Prod.xlsx"
:
"https://genpactonline.sharepoint.com/sites/Progear20_dev/DNA/_layouts/15/download.aspx?SourceUrl=%2Fsites%2FProgear20_dev%2FDNA%2FUAT%2FTemplate%2FDNC_Upload_FTE.xlsx"





export const PRODUCTIVITY_CLIENT_APPLICABLE = "RGFTE HC Reduction";
export const PRODUCTIVITY_GENPACT_APPLICABLE = "Reduction to Over Deployment Bench"
export const PRODUCTIVITY_GENPACT_APPLICABLE_RGFTE = "RGFTE HC Reduction"

export const IMPACT_TO_CLIENT='Impact at Client';
export const IMPACT_TO_GENPACT='Impact at Genpact';

export const NO_VD = "No Value Delivery";
export const VD_TO_CLIENT = "Value Delivered to Client";
export const VD_TO_GENPACT = "Value Delivered to Genpact";
export const VD_TO_CLIENT_PLUS_GENPACT = "Value Delivered to Client + Genpact";
export const IMPACTOPTIONS = [
  {
    value: 1,
    label: NO_VD
  },
  {
    value: 2,
    label: VD_TO_CLIENT
  },
  {
    value: 3,
    label: VD_TO_GENPACT
  },
  {
    value: 4,
    label: VD_TO_CLIENT_PLUS_GENPACT
  }
]

export const MONETIZATIONOPTIONS = [
  {
    value: 0,
    label: "Discussion to be initiated with Client"
  },
  {
    value: 1,
    label: "Discussion ongoing with Client"
  },
  {
    value: 2,
    label: "Rejected by Client"
  },
  {
    value: 4,
    label: "Approved by Client"
  }
]


export const PRODUCTIVITYGOLIVEDATE = "2025/7/19";

export const SOLUTIONCOMPLEXITY = [
  { value: 0, label: "High" },
  { value: 1, label: "Medium" },
  { value: 2, label: "Low" },
]

export const GENAIOPTIONS = [
  {
    value: 0,
    label: "Predict The Next Best Action"
  },
  {
    value: 1,
    label: "Automated Narrative Building and Translation"
  },
  {
    value: 2,
    label: "Data Extraction and Leakage Prevention"
  },
  {
    value: 3,
    label: "Coding Effort Reduction"
  },
]


export const MONETIZATION_FLOW_DISABLED_DATE = "2025-12-31"
            













